export default __webpack_public_path__ + "static/media/email.ca5d0845.png";